export interface CompanySearchModeConfig {
    placeholderKey?: string;
    placeholderParam?: string;
    hintKey?: string;
}

export interface CountrySearchConfig {
    searchByName?: CompanySearchModeConfig;
    searchByNumber?: CompanySearchModeConfig;
}

const K = {
    placeholderName:   'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.PLACEHOLDER.GENERIC_NAME',
    placeholderNumber: 'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.PLACEHOLDER.GENERIC_NUMBER',
    hintRegisteredName: 'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.HINT.REGISTERED_NAME',
    hintGbr:           'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.HINT.GBR_NUMBER',
    hintFra:           'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.HINT.FRA_NUMBER',
    hintNld:           'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.HINT.NLD_NUMBER',
    hintEsp:           'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.HINT.ESP_NUMBER',
} as const;

export const COMPANY_SEARCH_CONFIG: Record<string, CountrySearchConfig> = {
    fallback: {
        searchByName: {
            placeholderKey:   K.placeholderName,
            placeholderParam: 'Acme Ltd',
        },
        searchByNumber: {
            placeholderKey: '',
        },
    },
    GBR: {
        searchByName: {
            placeholderKey:   K.placeholderName,
            placeholderParam: 'Tesco PLC',
        },
        searchByNumber: {
            placeholderKey:   K.placeholderNumber,
            placeholderParam: '12345678',
            hintKey:          K.hintGbr,
        },
    },
    ITA: {
        searchByName: {
            placeholderKey:   K.placeholderName,
            placeholderParam: 'Ferrari Società per Azioni',
            hintKey:          K.hintRegisteredName,
        },
    },
    IRL: {
        searchByName: {
            placeholderKey:   K.placeholderName,
            placeholderParam: 'Kerry Group plc',
            hintKey:          K.hintRegisteredName,
        },
    },
    DEU: {
        searchByName: {
            placeholderKey:   K.placeholderName,
            placeholderParam: 'Robert Bosch GmbH',
            hintKey:          K.hintRegisteredName,
        },
    },
    FRA: {
        searchByName: {
            placeholderKey:   K.placeholderName,
            placeholderParam: 'Airbus SAS',
        },
        searchByNumber: {
            placeholderKey:   K.placeholderNumber,
            placeholderParam: '123456789',
            hintKey:          K.hintFra,
        },
    },
    NLD: {
        searchByName: {
            placeholderKey:   K.placeholderName,
            placeholderParam: 'ASML Holding',
        },
        searchByNumber: {
            placeholderKey:   K.placeholderNumber,
            placeholderParam: '12345678',
            hintKey:          K.hintNld,
        },
    },
    ESP: {
        searchByName: {
            placeholderKey:   K.placeholderName,
            placeholderParam: 'Indra Sistemas',
        },
        searchByNumber: {
            placeholderKey:   K.placeholderNumber,
            placeholderParam: 'A12345678',
            hintKey:          K.hintEsp,
        },
    },
};
